import * as React from "react";
import styled from "styled-components";
import { DayColumn } from "./DayColumn";
import { HoursColumn } from "./HoursColumn";
import { useCalendarContext } from "../CalendarContext";
import { ResourceKeyColumn } from "./ResourceKeyColumn";
import { ResourceDayColumn } from "./ResourceDayColumn";
export interface IWeekViewProps {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  flex: 1;
`;

const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  & > * + * {
    border-left: 1px solid black;
    border-right: 1px solid black;
  }
`;

export const WeekView: React.FunctionComponent<IWeekViewProps> = () => {
  const { days, horizontalResources } = useCalendarContext();

  return (
    <Container>
      <ColumnsContainer>
        {horizontalResources ? <ResourceKeyColumn /> : <HoursColumn />}
        {days.map((d, i) =>
          horizontalResources ? (
            <ResourceDayColumn day={d} key={i} />
          ) : (
            <DayColumn day={d} key={i} />
          )
        )}
      </ColumnsContainer>
    </Container>
  );
};
